import React, {useEffect, useState} from "react";
import SimilarityIndicator from "../SimilarityIndicator";
import SkillsModal from "../SkillsModal";
import axios from "axios";
import { Config } from "../../../../../../../Config";
import WarningModal from "./WarningModal";

const CandidateComparison = (props) => {
  const [SkillsModalIsOpen, setSkillsModalIsOpen] = useState(false);
  const [Skills, setSkills] = useState([]);
  const [CandidateInfo, setCandidateInfo] = useState();
  const [Languages, setLanguages] = useState([]);
  const [LangModalIsOpen, setLangModalIsOpen] = useState(false);
  const [FilterIDs] = useState([
    "similarity-up",
    "similarity-down",
    "name-up",
    "name-down",
    "jobTitle-up",
    "jobTitle-down",
    "yoe-up",
    "yoe-down",
  ]);
  const [SelectedFilters, setSelectedFilters] = useState({
    direction: "desc",
    category: "similarity",
  });
  const [WarningModalIsOpen, setWarningModalIsOpen] = useState(false);
  const [StickyIsOn, setStickyIsOn] = useState(false);
  const [ShownCandidateSkills, setShownCandidateSkills] = useState(() =>
      props?.Data.map(Item => Item.candidate?.topSkills?.slice(0, 3)))
  const [ObserverList, setObserverList] = useState([])

  useEffect(() => {
    props.Data.map((_, Idx) => {
      const targetRowEl = document.getElementById(Idx+"-table-row")
      const targetNode = document.getElementById(Idx+"filter-4")
      const config = { attributes: true, childList: true, subtree: true };

      targetRowEl.style.height = `${targetNode.clientHeight + 16}px`

      const handleELHeightChange = (mutationList) => {
        if(mutationList.findIndex(mutation => mutation.type === 'childList') > -1) {
          const TableRowEl = document.getElementById(Idx+"-table-row");
          TableRowEl.style.height = `${targetNode.clientHeight + 16}px`
        }
      }
      const observer = new MutationObserver(handleELHeightChange)
      observer.observe(targetNode,config)
      setObserverList(prevState => [...prevState, observer])
    })

    return () => {
      ObserverList.forEach(Observer => {
        Observer.disconnect()
      })
    }
  }, [])

  const handleShownCandidateSkills = (Idx) => {
    setShownCandidateSkills((prevState) => {
      return prevState?.map((TopSkills, TopSkillsIdx) => {
        const prevStateCopy = [...prevState]

        if (Idx === TopSkillsIdx) {
          const ShowLess = TopSkills.length > 3
          handleRowHeight(Idx, ShowLess)
          if (ShowLess) {
            prevStateCopy[Idx] = props?.Data?.find((_, ItemIdx) => Idx === ItemIdx)?.candidate?.topSkills?.slice(0, 3)
          } else {
            prevStateCopy[Idx] = props?.Data?.find((_, ItemIdx) => Idx === ItemIdx)?.candidate?.topSkills
          }
        }

        return prevStateCopy[TopSkillsIdx]
      })
    })
  }

  const handleRowHeight = (Idx, ShowLess) => {
    const Filter1El = document.getElementById(Idx + "-filter-1");

    if (ShowLess) {
      if (window.innerWidth < 450) {
        Filter1El.style.height = '88px';
      }
    } else {
      if (window.innerWidth < 450) {
        Filter1El.style.height = '140px';
      }
    }
  }

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  const shortenText = (TXT, Length) => {
    if (TXT.length < Length) {
      return TXT;
    } else {
      let Short = TXT.slice(0, Length - 4) + " ...";
      return (
        <>
          {Short}
          <p className="popup-text">{TXT}</p>
        </>
      );
    }
  };

  const handleSkillsModal = (Item) => {
    let Array = [];
    Item.topSkills.map((Skill) => {
      Array.push(Skill.title);
    });
    setSkills(Array);
    setCandidateInfo({
      name: Item.firstName + " " + Item.lastName,
      positionTitle: Item.currentPositionTitle,
    });

    setSkillsModalIsOpen(true);
  };

  const handleLanguagesModal = (Item) => {
    let Array = [];
    Item.language.map((Lang) => {
      Array.push(Lang.name);
    });
    setLanguages(Array);

    setCandidateInfo({
      name: Item.firstName + " " + Item.lastName,
      positionTitle: Item.currentPositionTitle,
    });

    setLangModalIsOpen(true);
  };

  const fetchData = (SortCategory, FilterId) => {
    let Direction = "desc";

    // finding the requested filter and direction
    if (FilterId === "similarity") {
      if (
        document.getElementById("similarity-up").classList.contains("active")
      ) {
        handleFiltersActiveStatus("similarity-down");
        Direction = "asc";
      } else {
        handleFiltersActiveStatus("similarity-up");
      }
    } else if (FilterId === "name") {
      if (document.getElementById("name-up").classList.contains("active")) {
        handleFiltersActiveStatus("name-down");
        Direction = "asc";
      } else {
        handleFiltersActiveStatus("name-up");
      }
    } else if (FilterId === "jobTitle") {
      if (document.getElementById("jobTitle-up").classList.contains("active")) {
        handleFiltersActiveStatus("jobTitle-down");
        Direction = "asc";
      } else {
        handleFiltersActiveStatus("jobTitle-up");
      }
    } else if (FilterId === "yoe") {
      if (document.getElementById("yoe-up").classList.contains("active")) {
        handleFiltersActiveStatus("yoe-down");
        Direction = "asc";
      } else {
        handleFiltersActiveStatus("yoe-up");
      }
    }
    // requesting update data on parent page
    props.FetchData(SortCategory, Direction);
    setSelectedFilters({
      direction: Direction,
      category: SortCategory,
    });
  };

  const handleFiltersActiveStatus = (ItemId) => {
    // remove all active classNames first
    FilterIDs.map((Id) => {
      document.getElementById(Id).classList.remove("active");
    });
    // adding active className to the requested element by id
    document.getElementById(ItemId).classList.add("active");
  };

  const toggleBookmark = (Id, CandidateID) => {
    if (
      document.getElementById(Id).classList.contains("bookmarked") ||
      document.getElementById(Id).classList.contains("bookmarked-animated")
    ) {
      document.getElementById(Id).classList.remove("bookmarked-animated");
      document.getElementById(Id).classList.remove("bookmarked-animated");
    } else {
      document.getElementById(Id).classList.add("bookmarked-animated");
    }
    let ReqURL;
    if (props.Type === "position") {
      ReqURL =
        window._env_.API_URL +
        Config.PositionServiceURL +
        "/api/position/preset/" +
        props.JPA.id +
        "/candidates/bookmark";
    } else if (props.Type === "project") {
      ReqURL =
        window._env_.API_URL +
        Config.ProjectServiceURL +
        "/api/project/preset/" +
        props.JPA.id +
        "/candidates/bookmark";
    } else if (props.Type === "activity") {
      ReqURL =
        window._env_.API_URL +
        Config.ActivityServiceURL +
        "/api/activity/preset/" +
        props.JPA.id +
        "/candidates/bookmark";
    }
    let Req = {
      method: "POST",
      baseURL: ReqURL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: {
        candidateId: CandidateID,
      },
    };
    axios(Req)
      .then((Res) => {
        // requesting update data on parent page
        props.FetchData(SelectedFilters.category, SelectedFilters.direction);
        console.log(Res);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  const toggleModal = () => {
    setWarningModalIsOpen(true);
  };

  const switchPathValue = (Path) => {
    if (Path === "skills") {
      return (
        <p className="chip-item">{translateText("wizard_improve_skills")}</p>
      );
    } else if (Path === "career") {
      return <p className="chip-item">{translateText("wizard_next_career")}</p>;
    } else if (Path === "income") {
      return (
        <p className="chip-item">{translateText("wizard_improve_income")}</p>
      );
    } else if (Path === "projects") {
      return (
        <p className="chip-item">{translateText("wizard_cool_projects")}</p>
      );
    }
  };

  const downloadExcel = () => {
    let URL = window._env_.API_URL;

    if (props.Type === "position") {
      URL =
        URL +
        Config.PositionServiceURL +
        "/api" +
        "/position" +
        "/preset/" +
        props.JPA.id +
        "/candidates/compare/export";
    } else if (props.Type === "project") {
      URL =
        URL +
        Config.ProjectServiceURL +
        "/api" +
        "/project" +
        "/preset/" +
        props.JPA.id +
        "/candidates/compare/export";
    } else {
      URL =
        URL +
        Config.ActivityServiceURL +
        "/api" +
        "/activity" +
        "/preset/" +
        props.JPA.id +
        "/candidates/compare/export";
    }

    let Data = [];
    props.Data.map((Item) => {
      Data.push(Item.candidate.id);
    });

    let Req = {
      method: "POST",
      responseType: "blob",
      baseURL: URL,
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        let URL = window.URL.createObjectURL(new Blob([Res.data]));
        let Link = document.createElement("a");
        Link.href = URL;
        Link.setAttribute(
          "download",
          "Recommended_candidates_" +
            props.JPA.title.replace(/\s/g, "") +
            ".xlsx"
        );
        document.body.appendChild(Link);
        Link.click();
        setTimeout(() => {
          document.body.removeChild(Link);
        }, 500);
      })
      .catch((Err) => {
        console.log(Err.response);
      });
  };

  // only on mobile devices
  const handleScrollEvents = (e) => {
    const Element = document
      .getElementById("viewport-detector")
      .getBoundingClientRect();
    if (Element.x < 0) {
      // scrolled and the elements are stuck so we need to add new classNames
      setStickyIsOn(true);
    } else {
      setStickyIsOn(false);
    }
  };

  return (
    <>
      {/* Mobile view */}
      {window.innerWidth <= 450 ? (
        <div className="comparison-wrapper">
          {WarningModalIsOpen ? (
            <WarningModal
              Close={() => setWarningModalIsOpen(false)}
              Confirm={() => props.Close()}
              LangData={props.LangData}
            />
          ) : null}
          {SkillsModalIsOpen ? (
            <SkillsModal
              Close={() => setSkillsModalIsOpen(false)}
              Skills={Skills}
              Title={CandidateInfo.name}
              Location={CandidateInfo.positionTitle}
              IsCandidateSkills={true}
              LangData={props.LangData}
            />
          ) : null}
          {LangModalIsOpen ? (
            <SkillsModal
              Close={() => setLangModalIsOpen(false)}
              Skills={Languages}
              Title={CandidateInfo.name}
              Location={CandidateInfo.positionTitle}
              IsCandidateSkills={false}
              LangData={props.LangData}
              ContentTitle={
                translateText("languages_plural") +
                " (" +
                Languages.length +
                ")"
              }
            />
          ) : null}
          <section className="header-top">
            <i
              className="feather-arrow-left"
              onClick={() => props.GoBack()}
            ></i>
            <h1>{translateText("candidates")}</h1>
            {window.innerWidth > 450 ? (
              <span className="export-btn" onClick={() => downloadExcel()}>
                <i className="feather-download"></i>
                {translateText("export_data_to_excel")}
              </span>
            ) : (
              <span className="export-btn" onClick={() => downloadExcel()}>
                <i className="feather-download"></i>
                {translateText("export")}
              </span>
            )}
          </section>
          <section className="btn-group">
            <span className="secondary" onClick={() => toggleModal()}>
              <i className="feather-arrow-left"></i> {translateText("back")}
            </span>
            <span
              className={
                props.CheckedCandidateIDs.length > 0
                  ? "primary"
                  : "primary disabled"
              }
              onClick={() => props.RemoveCheckedRows()}
            >
              <i className="feather-trash"></i> {translateText("remove")}
            </span>
          </section>
          <main
            className="comparison-body"
            id="comparison-body"
            onScroll={(e) => handleScrollEvents(e)}
          >
            <div className="table-wrapper">
              <section className="table-head">
                <p id="viewport-detector"></p>
                <div
                  className={
                    StickyIsOn
                      ? "filter-item filter-1 is-stuck"
                      : "filter-item filter-1"
                  }
                  onClick={() => fetchData("candidate.firstName", "name")}
                  id="name-filter"
                >
                  {translateText("names")}
                  <span className="filter-icons">
                    <i className="feather-chevron-up" id="name-up"></i>
                    <i className="feather-chevron-down" id="name-down"></i>
                  </span>
                </div>
                <div
                  className="filter-item filter-2"
                  onClick={() => fetchData("similarity", "similarity")}
                >
                  {translateText("similarity")}
                  <span className="filter-icons">
                    <i
                      className="feather-chevron-up active"
                      id="similarity-up"
                    ></i>
                    <i
                      className="feather-chevron-down"
                      id="similarity-down"
                    ></i>
                  </span>
                </div>
                <div
                  className="filter-item filter-3"
                  onClick={() => fetchData("currentPositionTitle", "jobTitle")}
                >
                  {translateText("job_title")}
                  <span className="filter-icons">
                    <i className="feather-chevron-up" id="jobTitle-up"></i>
                    <i className="feather-chevron-down" id="jobTitle-down"></i>
                  </span>
                </div>
                <div className="filter-item filter-4">
                  {translateText("skills")}
                </div>
                <div
                  className="filter-item filter-5"
                  onClick={() =>
                    fetchData("candidate.yearsOfExperience", "yoe")
                  }
                >
                  {translateText("yoe")}
                  <span className="filter-icons">
                    <i className="feather-chevron-up" id="yoe-up"></i>
                    <i className="feather-chevron-down" id="yoe-down"></i>
                  </span>
                </div>
                <div className="filter-item filter-6">
                  {translateText("languages")}
                </div>
                <div className="filter-item filter-7">
                  {translateText("wizard_your_path")}
                </div>
              </section>
              <section className="table-content">
                {props.Data.map((Item, Idx) => (
                  <div className="table-row" id={Idx+"-table-row"} key={Item.presetId}>
                    {/* name */}
                    <div
                      className={
                        StickyIsOn
                          ? "filter-item filter-1 is-stuck"
                          : "filter-item filter-1"
                      }
                      id={Idx+"-filter-1"}
                    >
                      {/* checkbox */}
                      <label className="blue-checkbox-rounded-label">
                        <input
                          onChange={() => props.UpdateCheckedCandidates(Item)}
                          type="checkbox"
                          className="blue-checkbox"
                          id={"checkbox-" + Item.presetId}
                        />
                        <i></i>
                      </label>
                      <p className="table-row-text">
                        {Item.candidate.firstName
                          ? shortenText(
                              Item.candidate.firstName +
                                " " +
                                Item.candidate.lastName,
                              13
                            )
                          : "N/A"}
                      </p>
                    </div>
                    {/* similarity indicator */}
                    <div className="filter-item filter-2">
                      <SimilarityIndicator
                        Percentage={parseInt(Item.candidate.similarity)}
                      />
                    </div>
                    {/* job-title */}
                    <div className="filter-item filter-3">
                      <p className="table-row-text">
                        {Item.candidate.currentPositionTitle
                          ? shortenText(Item.candidate.currentPositionTitle, 15)
                          : "N/A"}
                      </p>
                    </div>
                    {/* Skills */}
                    <div className="filter-item filter-4" id={Idx+"filter-4"}>
                      {Item.candidate.topSkills.length > 0 ? (
                        <div className="chips">
                          {ShownCandidateSkills[Idx].map(Skill => <p className="chip-item">{Skill.title}</p>)}
                          {Item.candidate.topSkills.length > 3 ? (
                            <span
                              className="chip-toggle"
                              onClick={() => handleShownCandidateSkills(Idx)}
                            >
                              {
                                ShownCandidateSkills[Idx].length > 3 ?
                                    <>
                                      {translateText("show_less")}
                                      <i className="feather-chevron-up"/>
                                    </>
                                   :
                                    <>
                                      {translateText("show_more")}
                                      <i className="feather-chevron-down"/>
                                    </>
                              }
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                    {/* YoE */}
                    <div className="filter-item filter-5">
                      <p className="table-row-text">
                        {Item.candidate.yearsOfExperience
                          ? Item.candidate.yearsOfExperience
                          : "N/A"}
                      </p>
                    </div>
                    {/* languages */}
                    <div className="filter-item filter-6">
                      {Item.candidate.language.length > 0 ? (
                        <div className="chips">
                          {[...Item.candidate.language]
                            .splice(0, 3)
                            .map((Lang) => (
                              <p className="chip-item">{Lang.name}</p>
                            ))}
                          {Item.candidate.language.length > 2 ? (
                            <span
                              className="chip-toggle"
                              onClick={() =>
                                handleLanguagesModal(Item.candidate)
                              }
                            >
                              <i className="feather-more-horizontal"></i>
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                    {/* your path */}
                    <div className="filter-item filter-7">
                      {Item.candidate.path ? (
                        <div className="chips">
                          {Item.candidate.path
                            .split(",")
                            .splice(0, 3)
                            .map((Path) => (
                              <>{switchPathValue(Path)}</>
                            ))}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                    {Item.bookmarked ? (
                      <button
                        className="bookmark-btn bookmarked"
                        id={Item.candidate.id + "-bookmark"}
                        onClick={() =>
                          toggleBookmark(
                            Item.candidate.id + "-bookmark",
                            Item.candidate.id
                          )
                        }
                      >
                        <p className="popup">{translateText("unsave")}</p>
                      </button>
                    ) : (
                      <button
                        className="bookmark-btn"
                        id={Item.candidate.id + "-bookmark"}
                        onClick={() =>
                          toggleBookmark(
                            Item.candidate.id + "-bookmark",
                            Item.candidate.id
                          )
                        }
                      >
                        <p className="popup">{translateText("save")}</p>
                      </button>
                    )}
                  </div>
                ))}
              </section>
            </div>
          </main>
        </div>
      ) : (
        <div className="comparison-wrapper">
          {/* Desktop view */}
          {WarningModalIsOpen ? (
            <WarningModal
              Close={() => setWarningModalIsOpen(false)}
              Confirm={() => props.Close()}
              LangData={props.LangData}
            />
          ) : null}
          {SkillsModalIsOpen ? (
            <SkillsModal
              Close={() => setSkillsModalIsOpen(false)}
              Skills={Skills}
              Title={CandidateInfo.name}
              Location={CandidateInfo.positionTitle}
              IsCandidateSkills={true}
              LangData={props.LangData}
            />
          ) : null}
          {LangModalIsOpen ? (
            <SkillsModal
              Close={() => setLangModalIsOpen(false)}
              Skills={Languages}
              Title={CandidateInfo.name}
              Location={CandidateInfo.positionTitle}
              IsCandidateSkills={false}
              LangData={props.LangData}
              ContentTitle={
                translateText("languages_plural") +
                " (" +
                Languages.length +
                ")"
              }
            />
          ) : null}
          <section className="header-top">
            <i
              className="feather-arrow-left"
              onClick={() => props.GoBack()}
            ></i>
            <h1>{translateText("candidates")}</h1>
            {window.innerWidth > 450 ? (
              <span className="export-btn" onClick={() => downloadExcel()}>
                <i className="feather-download"></i>
                {translateText("export_data_to_excel")}
              </span>
            ) : (
              <span className="export-btn" onClick={() => downloadExcel()}>
                <i className="feather-download"></i>
                {translateText("export")}
              </span>
            )}
          </section>
          <main className="comparison-body">
            <section className="btn-group">
              <span className="secondary" onClick={() => toggleModal()}>
                <i className="feather-arrow-left"></i> {translateText("back")}
              </span>
              <span
                className={
                  props.CheckedCandidateIDs.length > 0
                    ? "primary"
                    : "primary disabled"
                }
                onClick={() => props.RemoveCheckedRows()}
              >
                <i className="feather-trash"></i> {translateText("remove")}
              </span>
            </section>
            <div className="table-wrapper">
              <section className="table-head">
                <div
                  className="filter-item filter-1"
                  onClick={() => fetchData("similarity", "similarity")}
                >
                  {translateText("similarity")}
                  <span className="filter-icons">
                    <i
                      className="feather-chevron-up active"
                      id="similarity-up"
                    ></i>
                    <i
                      className="feather-chevron-down"
                      id="similarity-down"
                    ></i>
                  </span>
                </div>
                <div
                  className="filter-item filter-2"
                  onClick={() => fetchData("candidate.firstName", "name")}
                >
                  {translateText("names")}
                  <span className="filter-icons">
                    <i className="feather-chevron-up" id="name-up"></i>
                    <i className="feather-chevron-down" id="name-down"></i>
                  </span>
                </div>
                <div
                  className="filter-item filter-3"
                  onClick={() => fetchData("currentPositionTitle", "jobTitle")}
                >
                  {translateText("job_title")}
                  <span className="filter-icons">
                    <i className="feather-chevron-up" id="jobTitle-up"></i>
                    <i className="feather-chevron-down" id="jobTitle-down"></i>
                  </span>
                </div>
                <div className="filter-item filter-4">
                  {translateText("skills")}
                </div>
                <div
                  className="filter-item filter-5"
                  onClick={() =>
                    fetchData("candidate.yearsOfExperience", "yoe")
                  }
                >
                  {translateText("yoe")}
                  <span className="filter-icons">
                    <i className="feather-chevron-up" id="yoe-up"></i>
                    <i className="feather-chevron-down" id="yoe-down"></i>
                  </span>
                </div>
                <div className="filter-item filter-6">
                  {translateText("languages")}
                </div>
                <div className="filter-item filter-7">
                  {translateText("wizard_your_path")}
                </div>
              </section>
              <section className="table-content">
                {props.Data.map((Item, Idx) => (
                  <div className="table-row" id={Idx+"-table-row"} key={Item.presetId}>
                    {/* checkbox */}
                    <label className="blue-checkbox-rounded-label">
                      <input
                        onChange={() => props.UpdateCheckedCandidates(Item)}
                        type="checkbox"
                        className="blue-checkbox"
                        id={"checkbox-" + Item.presetId}
                      />
                      <i></i>
                    </label>
                    {/* user profile image */}
                    <>
                      {Item.candidate.imageThumbnailUrl !== null ? (
                        <div className="candidate-avatar">
                          <img
                            alt={
                              Item.candidate.firstName
                                .slice(0, 1)
                                .toUpperCase() +
                              Item.candidate.lastName.slice(0, 1).toUpperCase()
                            }
                            src={Item.candidate.imageThumbnailUrl}
                          />
                        </div>
                      ) : (
                        <div
                          className="candidate-avatar"
                          style={{
                            background: Item.candidate.backgroundColorCode,
                            color: Item.candidate.textColorCode,
                          }}
                        >
                          {Item.candidate.firstName.slice(0, 1).toUpperCase() +
                            Item.candidate.lastName.slice(0, 1).toUpperCase()}
                        </div>
                      )}
                    </>
                    {/* similarity indicator */}
                    <div className="filter-item filter-1" id={Idx+"-filter-1"}>
                      <SimilarityIndicator
                        Percentage={parseInt(Item.candidate.similarity)}
                      />
                    </div>
                    {/* name */}
                    <div className="filter-item filter-2">
                      <p className="table-row-text">
                        {Item.candidate.firstName
                          ? shortenText(
                              Item.candidate.firstName +
                                " " +
                                Item.candidate.lastName,
                              9
                            )
                          : "N/A"}
                      </p>
                    </div>
                    {/* job-title */}
                    <div className="filter-item filter-3">
                      <p className="table-row-text">
                        {Item.candidate.currentPositionTitle
                          ? shortenText(Item.candidate.currentPositionTitle, 15)
                          : "N/A"}
                      </p>
                    </div>
                    {/* Skills */}
                    <div className="filter-item filter-4" id={Idx+"filter-4"}>
                      {Item.candidate.topSkills.length > 0 ? (
                        <div className="chips">
                          {ShownCandidateSkills[Idx].map(Skill => <p className="chip-item">{Skill.title}</p>)}
                          {Item.candidate.topSkills.length > 3 ? (
                            <span
                              className="chip-toggle"
                              onClick={() => handleShownCandidateSkills(Idx)}
                            >
                              {
                                ShownCandidateSkills[Idx].length > 3 ?
                                    <>
                                      {translateText("show_less")}
                                      <i className="feather-chevron-up"/>
                                    </>
                                    :
                                    <>
                                      {translateText("show_more")}
                                      <i className="feather-chevron-down"/>
                                    </>
                              }
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                    {/* YoE */}
                    <div className="filter-item filter-5">
                      <p className="table-row-text">
                        {Item.candidate.yearsOfExperience
                          ? Item.candidate.yearsOfExperience
                          : "N/A"}
                      </p>
                    </div>
                    {/* languages */}
                    <div className="filter-item filter-6">
                      {Item.candidate.language.length > 0 ? (
                        <div className="chips">
                          {[...Item.candidate.language]
                            .splice(0, 3)
                            .map((Lang, Idx) => (
                              <p className="chip-item" key={Idx}>{Lang.name}</p>
                            ))}
                          {Item.candidate.language.length > 2 ? (
                            <span
                              className="chip-toggle"
                              onClick={() =>
                                handleLanguagesModal(Item.candidate)
                              }
                            >
                              <i className="feather-more-horizontal"></i>
                            </span>
                          ) : null}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                    {/* your path */}
                    <div className="filter-item filter-7">
                      {Item.candidate.path ? (
                        <div className="chips">
                          {Item.candidate.path
                            .split(",")
                            .splice(0, 3)
                            .map((Path) => (
                              <>{switchPathValue(Path)}</>
                            ))}
                        </div>
                      ) : (
                        "N/A"
                      )}
                    </div>
                    {Item.bookmarked ? (
                      <button
                        className="bookmark-btn bookmarked"
                        id={Item.candidate.id + "-bookmark"}
                        onClick={() =>
                          toggleBookmark(
                            Item.candidate.id + "-bookmark",
                            Item.candidate.id
                          )
                        }
                      >
                        <p className="popup">{translateText("unsave")}</p>
                      </button>
                    ) : (
                      <button
                        className="bookmark-btn"
                        id={Item.candidate.id + "-bookmark"}
                        onClick={() =>
                          toggleBookmark(
                            Item.candidate.id + "-bookmark",
                            Item.candidate.id
                          )
                        }
                      >
                        <p className="popup">{translateText("save")}</p>
                      </button>
                    )}
                  </div>
                ))}
              </section>
            </div>
          </main>
        </div>
      )}
    </>
  );
};

export default CandidateComparison;
